import { atom } from '@reatom/framework'
import { withLocalStorage } from '@reatom/persist-web-storage'

import { STORAGE_PREFIX } from '@root/shared/constants'

import * as Theme from '../model/theme'
import { ThemeId } from '../model/theme-id'

import { currentCustomUiThemeAtom } from './current-custom-theme-atom'

const STORAGE_KEY = `${STORAGE_PREFIX}/v1/current-theme-id`

export const currentThemeIdAtom = atom<ThemeId | 'custom'>(
  ThemeId.Deluge,
  'currentThemeIdAtom',
).pipe(withLocalStorage(STORAGE_KEY))

export const currentThemeAtom = atom((ctx) => {
  const currentThemeId = ctx.spy(currentThemeIdAtom)

  return currentThemeId === 'custom'
    ? ctx.spy(currentCustomUiThemeAtom)
    : Theme.themesMap[currentThemeId].uiTheme
}, 'currentThemeAtom')
